import { TreeItem, TreeItemWithRecord, ItemType } from './item';
import { DossierTree } from './tree';
import { RecordLink } from '../../record-link/record-link';


export class RecordItem extends TreeItem implements TreeItemWithRecord {

  link: RecordLink;

  constructor(link: RecordLink, parent: TreeItem, tree: DossierTree) {
    super(parent, tree);
    this.link = link;
  }

  get type(): ItemType {
    return 'RECORD';
  }

  get label(): string {
    return this.link.record.name;
  }

  get isNew(): boolean {
    return !this.link.id;
  }
}